export default {
  setSuperUserGnipArchiveDisconnections(state, payload) {
    state.superUserGnipArchiveDisconnections = payload;
  },
  setSuperUserCollectActiveWorkspaces(state, payload) {
    return (state.superUserCollectActiveWorkspaces = payload);
  },
};
